import { Box, Button, Typography } from '@mui/material';

import muiStyles from './muiStyles';
import styles from './styles.module.css';

import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import { initialAlertState, useAlertStatus } from 'customHook/useAlertStatus';
import { useRef, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

const Header = ({ data, isTargeted = false }: { data: any; isTargeted: boolean }) => {
  const { alertState, startOperation, completeOperation, setAlertState, getAlertContent } =
    useAlertStatus();
  const [isTarget, setIsTarget] = useState(isTargeted);
  const { logo, name, website, id } = data || {};
  const targetTextContent = isTarget ? 'Remove' : 'Target';
  const targetId = useRef(id);

  const toggleTarget = async () => {
    try {
      if (isTarget) {
        startOperation('delete', 'Removing Account...');
        await BusinessesService.removeTarget(targetId.current ?? '');
        completeOperation('delete', 'Account Removed');
      } else {
        startOperation('upload', 'Targeting Account...');
        const res = await BusinessesService.addTarget({
          zoominfoCompanyId: String(id),
          category: 'Brand',
        });
        targetId.current = res.business.businessId;
        completeOperation('upload', 'Account Targeted');
      }
      setIsTarget(!isTarget);
    } catch (error: any) {
      console.log(error);
      completeOperation('upload', String(error), true);
    }
  };

  return (
    <Box sx={muiStyles.container}>
      <Box sx={muiStyles.companyIdentity}>
        <img
          src={logo}
          alt='logo'
          loading='lazy'
          className={styles.logo}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = '/assets/zoominfo-fallback.svg';
          }}
        />

        <Box sx={muiStyles.companyMetaContainer}>
          <Box sx={muiStyles.companyMeta}>
            <Typography variant='responsiveHeading1'>{name}</Typography>
            <Button onClick={toggleTarget} sx={muiStyles.targetButton}>
              <Typography variant='responsiveButtonSmall'>{targetTextContent} Account</Typography>
            </Button>
          </Box>

          <Box sx={muiStyles.websiteContainer}>
            <img
              src={'/assets/zoominfo-website.svg'}
              alt='website'
              loading='lazy'
              className={styles.website}
            />
            <a
              href={'https://' + website}
              className={styles.link}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Typography variant='responsiveBody3'>{website}</Typography>
            </a>
          </Box>
        </Box>
      </Box>

      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </Box>
  );
};

export default Header;
